/* Minent — revenus de minage en direct (cartes, fiche produit, Top 5).
   Données réseau et cours : api.minent.eu (mêmes sources que le calculateur).
   Valeurs de repli : window.MC_DATA (assets/minent-calc-data.js) si présent. */
(function () {
  'use strict';
  var TWO32 = 4294967296;
  var LANG = (document.documentElement.lang || 'fr').slice(0, 2);
  var LOC = { fr: 'fr-FR', en: 'en-IE', de: 'de-DE', es: 'es-ES', it: 'it-IT', nl: 'nl-NL', cs: 'cs-CZ' }[LANG] || 'fr-FR';
  var CG = { BTC: 'bitcoin', LTC: 'litecoin', DOGE: 'dogecoin', KAS: 'kaspa', ZEC: 'zcash', XMR: 'monero', ALEO: 'aleo', CKB: 'nervos-network', ETC: 'ethereum-classic' };
  var CC = { BTC: '#f7931a', LTC: '#345d9d', DOGE: '#c2a633', KAS: '#49c68e', ZEC: '#ecb440', XMR: '#ff6600', ALEO: '#00bcd4', CKB: '#3cc864', ETC: '#328332' };
  var NET = { BTC: { type: 'diff', diff: 140577680051919, reward: 3.1338 }, LTC: { type: 'diff', diff: 83522829, reward: 6.25 }, DOGE: { type: 'diff', diff: 62000000, reward: 10000 }, KAS: { type: 'nh', nh: 379424138863603500, bt: 0.0999, reward: 2.06 }, ZEC: { type: 'nh', nh: 27719737102, bt: 75, reward: 1.25 }, XMR: { type: 'nh', nh: 6444971181, bt: 114, reward: 0.6035 }, ALEO: { type: 'nh', nh: 8.67e12, bt: 25, reward: 15 }, CKB: { type: 'nh', nh: 2.34e17, bt: 10, reward: 612 }, ETC: { type: 'nh', nh: 163282408027703, bt: 13.61, reward: 1.589 } };
  var PX = {};
  var D = null;
  function readData() {
    if (D || !window.MC_DATA) return;
    D = window.MC_DATA;
    if (D.net) Object.keys(D.net).forEach(function (k) { NET[k] = D.net[k]; });
    if (D.prices) Object.keys(D.prices).forEach(function (k) { if (D.prices[k] && D.prices[k].eur) PX[k] = D.prices[k].eur; });
  }

  function eur(x, max) {
    return new Intl.NumberFormat(LOC, { style: 'currency', currency: 'EUR', maximumFractionDigits: max == null ? 2 : max, minimumFractionDigits: max === 0 ? 0 : 2 }).format(x);
  }
  function num(x, d) { return new Intl.NumberFormat(LOC, { maximumFractionDigits: d == null ? 2 : d }).format(x); }

  function detectCoin(coins, algo) {
    var map = { btc: 'BTC', bitcoin: 'BTC', ltc: 'LTC', litecoin: 'LTC', doge: 'DOGE', dogecoin: 'DOGE', kas: 'KAS', kaspa: 'KAS', zec: 'ZEC', zcash: 'ZEC', xmr: 'XMR', monero: 'XMR', aleo: 'ALEO', ckb: 'CKB', nervos: 'CKB', etc: 'ETC' };
    var s = (coins || '').toLowerCase().replace(/[\[\]"'()]/g, ' ');
    var t = s.split(/[,|\s;]+/).filter(Boolean);
    var found = t.map(function (x) { return map[x]; }).filter(Boolean);
    if (found.indexOf('LTC') > -1) return 'LTC';
    if (found.indexOf('BTC') > -1) return 'BTC';
    if (found.length) return found[0];
    if (s.indexOf('ethereum classic') > -1) return 'ETC';
    var a = (algo || '').toLowerCase();
    if (a.indexOf('sha') > -1) return 'BTC';
    if (a.indexOf('scrypt') > -1) return 'LTC';
    if (a.indexOf('kheavy') > -1 || a.indexOf('kaspa') > -1) return 'KAS';
    if (a.indexOf('equihash') > -1) return 'ZEC';
    if (a.indexOf('randomx') > -1) return 'XMR';
    if (a.indexOf('aleo') > -1) return 'ALEO';
    if (a.indexOf('eagle') > -1) return 'CKB';
    if (a.indexOf('ethash') > -1 || a.indexOf('etchash') > -1) return 'ETC';
    return null;
  }
  function toHps(v, u) {
    v = parseFloat(String(v).replace(',', '.'));
    if (!v || isNaN(v)) return 0;
    var s = (u || '').toLowerCase();
    if (s.indexOf('ph') > -1) return v * 1e15;
    if (s.indexOf('th') > -1) return v * 1e12;
    if (s.indexOf('gh') > -1) return v * 1e9;
    if (s.indexOf('mh') > -1) return v * 1e6;
    if (s.indexOf('kh') > -1 || s.indexOf('ksol') > -1) return v * 1e3;
    return v;
  }
  /* revenu brut en € par jour + production en pièces */
  function revenue(hps, coin) {
    var n = NET[coin], px = PX[coin];
    if (!n || !hps) return null;
    var coins = n.type === 'diff' ? (hps * 86400 * n.reward) / (n.diff * TWO32) : (hps / n.nh) * (86400 / n.bt) * n.reward;
    var e = px ? coins * px : 0;
    if (coin === 'LTC' && NET.DOGE && PX.DOGE) e += ((hps * 86400 * NET.DOGE.reward) / (NET.DOGE.diff * TWO32)) * PX.DOGE;
    return { coins: coins, eur: e };
  }

  /* ---------- cartes ---------- */
  var VER = 0;
  function paintCards(onlyNew) {
    document.querySelectorAll('[data-mn-rev]').forEach(function (el) {
      if (onlyNew && el.dataset.mnV === String(VER)) return;
      el.dataset.mnV = String(VER);
      var coin = detectCoin(el.dataset.coins, el.dataset.algo);
      var r = coin ? revenue(toHps(el.dataset.hr, el.dataset.hu), coin) : null;
      var out = el.querySelector('strong');
      if (!r || !r.eur) { el.classList.add('is-na'); if (out) out.textContent = '—'; return; }
      el.classList.remove('is-na');
      if (out) out.textContent = '+' + eur(r.eur);
    });
  }

  /* ---------- fiche produit ---------- */
  function paintRoi() {
    document.querySelectorAll('[data-mn-roi]').forEach(function (box) {
      var coin = detectCoin(box.dataset.coins, box.dataset.algo);
      var hps = toHps(box.dataset.hr, box.dataset.hu);
      var r = coin ? revenue(hps, coin) : null;
      var q = function (s) { return box.querySelector(s); };
      if (!r || !r.eur) { box.hidden = true; return; }
      box.hidden = false;
      var price = parseFloat(box.dataset.price || '0') / 100;
      var watts = parseFloat(box.dataset.watts || '0');
      var kwh = parseFloat(((q('[data-mn-kwh]') || {}).value || '0').replace(',', '.')) || 0;
      var cost = (watts * 24 / 1000) * kwh;
      var net = r.eur - cost;
      if (q('[data-mn-day]')) { q('[data-mn-day]').textContent = (net >= 0 ? '+' : '') + eur(net); q('[data-mn-day]').classList.toggle('is-green', net > 0); }
      if (q('[data-mn-month]')) q('[data-mn-month]').textContent = eur(net * 30.42, 0);
      if (q('[data-mn-prod]')) q('[data-mn-prod]').textContent = num(r.coins, r.coins < 1 ? 6 : 2) + ' ' + coin;
      if (q('[data-mn-coinpx]')) q('[data-mn-coinpx]').textContent = PX[coin] ? coin + ' · ' + eur(PX[coin], PX[coin] < 1 ? 4 : 2) : '';
      if (q('[data-mn-be]')) q('[data-mn-be]').textContent = watts > 0 ? num(r.eur / (watts * 24 / 1000), 3) + ' €/kWh' : '—';
      if (q('[data-mn-year]')) q('[data-mn-year]').textContent = eur(net * 365, 0);
      if (q('[data-mn-net]')) {
        var n = NET[coin], txt = '—';
        if (n && n.type === 'diff') txt = coin + ' · diff. ' + num(n.diff / 1e12, 2) + ' T · ' + num(n.reward, 4) + ' ' + coin + '/bloc';
        else if (n) txt = coin + ' · ' + num(n.nh / 1e12 >= 1 ? n.nh / 1e12 : n.nh / 1e9, 2) + (n.nh / 1e12 >= 1 ? ' T' : ' G') + 'H/s · ' + num(n.reward, 4) + ' ' + coin + '/bloc';
        q('[data-mn-net]').textContent = txt;
      }
      if (q('[data-mn-roi-val]')) {
        var m = net > 0 && price > 0 ? price / net / 30.42 : null;
        q('[data-mn-roi-val]').textContent = m ? num(m, 1) + ' ' + (box.dataset.months || 'mois') : '—';
      }
    });
  }

  /* ---------- Top 5 de l'accueil ---------- */
  function paintTop() {
    var box = document.querySelector('[data-mn-top]');
    if (!box || !D || !D.miners) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var limit = parseInt(box.dataset.count || '5', 10);
    var only = box.dataset.filter || 'all';
    var rows = D.miners.filter(function (m) { return only === 'all' || m.st === 'ok'; }).map(function (m) {
      var r = revenue(toHps(m.hr, m.u), m.c);
      return { m: m, rev: r ? r.eur : 0 };
    }).filter(function (x) { return x.rev > 0; }).sort(function (a, b) { return b.rev - a.rev; }).slice(0, limit);
    var L = JSON.parse(box.dataset.labels || '{}');
    var list = box.querySelector('[data-mn-top-list]');
    if (!list) return;
    list.innerHTML = rows.map(function (x, i) {
      var m = x.m;
      var url = (m.url || '').replace(/^https?:\/\/[^/]+\//, root);
      var st = m.st === 'pre' ? '<span class="mn-pill mn-pill--pre">' + (L.pre || '') + '</span>' : m.st === 'no' ? '<span class="mn-pill mn-pill--no">' + (L.no || '') + '</span>' : m.st === 'ok' ? '<span class="mn-pill mn-pill--ok">' + (L.ok || '') + '</span>' : '';
      return '<li><a class="mn-top__row" href="' + url + '">' +
        '<span class="mn-top__rank">#' + (i + 1) + '</span>' +
        '<span><span class="mn-top__name">' + m.n + '</span><span class="mn-top__meta"><span class="mn-coin" style="--c:' + (CC[m.c] || '#999') + '"><i></i>' + m.c + '</span><span class="mn-num">' + num(m.hr, 0) + ' ' + m.u + '</span>' + st + '</span></span>' +
        '<span class="mn-top__val"><span class="mn-top__rev">+' + eur(x.rev) + '<small>/' + (L.day || 'j') + '</small></span>' +
        (m.price ? '<span class="mn-top__price">' + eur(m.price, 0) + '</span>' : '') + '</span>' +
        '</a></li>';
    }).join('');
  }

  function paintAll() { VER++; paintCards(false); paintRoi(); paintTop(); try { document.dispatchEvent(new CustomEvent('mn:live')); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mn-top-filter]');
    if (!b) return;
    var box = b.closest('[data-mn-top]'); if (!box) return;
    box.dataset.filter = b.dataset.mnTopFilter;
    box.querySelectorAll('[data-mn-top-filter]').forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
    paintTop();
  });
  window.MinentLive = { refresh: paintAll, revenue: revenue, detectCoin: detectCoin, toHps: toHps, data: function () { readData(); return D; }, price: function (c) { return PX[c]; }, eur: eur, num: num, colors: CC };

  function get(url, ms) {
    var c = 'AbortController' in window ? new AbortController() : null;
    if (c) setTimeout(function () { c.abort(); }, ms || 8000);
    return fetch(url, c ? { signal: c.signal } : {}).then(function (r) { return r.json(); });
  }
  function loadPrices() {
    return get('https://api.minent.eu/prices.json', 6000).then(function (d) {
      Object.keys(CG).forEach(function (k) { if (d[CG[k]] && d[CG[k]].eur) PX[k] = d[CG[k]].eur; });
    }).catch(function () {});
  }
  function loadNet() {
    return get('https://api.minent.eu/network.json', 8000).then(function (data) {
      readData();
      var n = data && data.network; if (!n) return;
      Object.keys(n).forEach(function (sym) {
        var c = n[sym]; if (!c) return;
        var br = c.block_reward || 0, bt = c.block_time || 0, diff = c.difficulty || 0, nh = c.nethash || 0;
        if ((sym === 'BTC' && diff > 1e12) || ((sym === 'LTC' || sym === 'DOGE') && diff > 0)) NET[sym] = { type: 'diff', diff: diff, reward: br };
        else if (nh > 0 && bt > 0 && br > 0) NET[sym] = { type: 'nh', nh: nh, bt: bt, reward: br };
      });
    }).catch(function () {});
  }

  var started = false;
  function start() {
    if (started) return;
    started = true;
    readData();
    paintAll();
    Promise.all([loadPrices(), loadNet()]).then(paintAll);
    document.addEventListener('input', function (e) { if (e.target && e.target.matches('[data-mn-kwh]')) paintRoi(); });
    setInterval(function () { loadPrices().then(paintAll); }, 600000);
    /* produits ajoutés dynamiquement (filtres de collection, recommandations) */
    if ('MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { paintCards(true); }, 150); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'complete') start();
  else { document.addEventListener('DOMContentLoaded', start); window.addEventListener('load', start); }
})();
